var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.7559,
    cy: 10,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.755859 10.0001C0.755859 4.47714 5.23318 0 10.7559 0C16.2787 0 20.7559 4.47714 20.7559 10.0001C20.7559 15.5229 16.2787 20 10.7559 20C5.23318 20 0.755859 15.5229 0.755859 10.0001ZM1.55596 10.0001C1.55596 15.0729 5.68282 19.2001 10.7559 19.2001C15.8287 19.2001 19.9559 15.0729 19.9559 10.0001C19.9559 4.92696 15.8287 0.799921 10.7559 0.799921C5.68282 0.799921 1.55596 4.92696 1.55596 10.0001ZM9.85271 14.0971V10.903H6.65897C6.16018 10.903 5.7559 10.4987 5.7559 10.0001C5.7559 9.50131 6.16018 9.09685 6.65897 9.09685H9.85271V5.90293C9.85271 5.40415 10.2572 5.00004 10.7559 5.00004C11.2545 5.00004 11.659 5.40415 11.659 5.90293V9.09685H14.8529C15.3517 9.09685 15.756 9.50131 15.756 10.0001C15.756 10.4987 15.3517 10.903 14.8529 10.903H11.659V14.0971C11.659 14.5957 11.2545 15 10.7559 15C10.2572 15 9.85271 14.5957 9.85271 14.0971Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSectionIcon);
export default __webpack_public_path__ + "static/media/addSectionIcon.cde18d658ed7ecdc8662ea2a33e35e18.svg";
export { ForwardRef as ReactComponent };